import { render, staticRenderFns } from "./CameraCreateDialog.vue?vue&type=template&id=b23c7e18&scoped=true"
import script from "./CameraCreateDialog.vue?vue&type=script&lang=js"
export * from "./CameraCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./CameraCreateDialog.vue?vue&type=style&index=0&id=b23c7e18&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23c7e18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b23c7e18')) {
      api.createRecord('b23c7e18', component.options)
    } else {
      api.reload('b23c7e18', component.options)
    }
    module.hot.accept("./CameraCreateDialog.vue?vue&type=template&id=b23c7e18&scoped=true", function () {
      api.rerender('b23c7e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/camera/CameraCreateDialog.vue"
export default component.exports